import React from 'react'
import LandingBox from '../../landing-box'
import { SignUpButton } from '../../nav/login-buttons'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'

@i18n()
export default class RegistrationBanner extends Configurator {

    render() {
        const {
            title,
            buttonText,
            contactButton,
            buttonUrl,
            buttonOutside,
            t,
        } = this.props

        return (
            <LandingBox boxWhiteBg className="Landing-box__registration-banner">
                <div className="container">
                    <div className="row Landing-box__connect-box Landing-box__connect-box--registration-banner">
                        <div className="col-lg-6 col-md-12 Landing-box__connect-box-text px-4 px-sm-0">
                            <h2 dangerouslySetInnerHTML={{ __html: title }} />
                            <div className="mx-auto">
                                {contactButton &&
                                    <a
                                        className="btn btn-color-brand btn-xl btn-circle Landing-main-box__button"
                                        href={`mailto:${this.config.REACT_APP_CONTACT_EMAIL}`}
                                    >
                                        {t('landingTournamentOrganizer.registrationBanner.buttonText')}
                                    </a>
                                }
                                {!contactButton &&
                                    <SignUpButton
                                        url={buttonUrl}
                                        buttonOutside={buttonOutside}
                                    >
                                        {buttonText}
                                    </SignUpButton>
                                }
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 Landing-box__connect-box-image d-flex align-items-end">
                            <img src="/images/landing/sn-landing-page-man.png" alt="" />
                        </div>
                    </div>
                </div>
                <div className="Landing-box__gradient-line"/>
            </LandingBox>
        )
    }
}
